import { useServices } from './useServices';

export const useImageRotator = () => {
  return useServices().imageRotator;
};
